import { render } from "./ReferentialEditor.vue?vue&type=template&id=4aa8d116&scoped=true"
import script from "./ReferentialEditor.vue?vue&type=script&lang=js"
export * from "./ReferentialEditor.vue?vue&type=script&lang=js"

import "./ReferentialEditor.vue?vue&type=style&index=0&id=4aa8d116&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa8d116"],['__file',"src/components/admin/ReferentialEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4aa8d116"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4aa8d116', __exports__)) {
    api.reload('4aa8d116', __exports__)
  }
  
  module.hot.accept("./ReferentialEditor.vue?vue&type=template&id=4aa8d116&scoped=true", () => {
    api.rerender('4aa8d116', render)
  })

}


export default __exports__